import React, { Component } from 'react'
import { string, arrayOf, func, shape, oneOfType, number, bool } from 'prop-types'
import { isStriclyEqual, validateRules } from '../../../utilities/validators'

export class Input extends Component {
  constructor ({ name }) {
    super()
    this.state = {
      isValid: true,
      errors: [],
      name: name
    }
  }

  get value () {
    return this.state.value || this.props.value || ''
  }

  componentWillReceiveProps (nextprops) {
    this.setState({ value: nextprops.value })
  }

  validate () {
    const value = this.refs[this.props.name].value
    let errors = []
    if (this.props.rules) {
      errors = validateRules(this.props.rules, value).errors
    }
    // Check if one field associated if the values are the same
    if (this.props.associated) {
      const associated = this.props.associated() || {}
      if (!isStriclyEqual(associated.value, value)) {
        errors.push({expected: associated.name, message: 'Les 2 mots de passes ne sont pas identiques !', type: 'fieldValue'})
      }
    }
    return { errors, isValid: !errors.length }
  }

  handleChange () {
    const value = this.refs[this.props.name].value
    const { isValid, errors } = this.validate()

    if (this.props.onChange) {
      this.props.onChange(value, isValid)
    }
    this.setState({ value })
    clearTimeout(this._rulesValidationTimeout)
    this._rulesValidationTimeout = setTimeout(() => {
      this.setState({ isValid, errors })
    }, 500)
  }

  /*
   * Validation handler called on value change
   */
  handleValidation () {
    const result = this.validate()
    this.setState({...result})
    return { label: this.props.label, ...result }
  }

  render () {
    const {
      bold,
      className,
      type,
      label,
      name,
      instructions,
      placeholder
    } = this.props
    const { isValid, errors } = this.state
    return (
      <div>
        <div className='clearfix'>
          <label style={(bold) ? {fontWeight: 500} : {}} className={'form__label ' + (!isValid ? 'form__label--error' : '')} htmlFor={name} >
            {label}
            <span style={{fontWeight: 100, fontStyle: 'italic'}}> {instructions}</span>
          </label>
          <input
            defaultValue={this.props.value}
            onBlur={() => this.handleValidation()}
            onChange={() => this.handleChange()}
            className={(className ? className + ' form__input' : 'form__input') + (errors.length ? ' form__input--error' : '')}
            type={type}
            ref={name}
            id={name}
            placeholder={placeholder} />
        </div>
        {errors.length ? <p className='form__errormessage'>{errors[0].message}</p> : ''}
      </div>
    )
  }
}

Input.propTypes = {
  label: string.isRequired,
  name: string.isRequired,
  type: string.isRequired,
  rules: arrayOf(shape({
    type: string,
    message: string,
    expected: oneOfType([
      string,
      number,
      bool
    ])
  })),
  value: string,
  instructions: string,
  placeholder: string,
  onChange: func,
  className: string,
  associated: func,
  bold: bool
}

Input.defaultProps = {
  value: ''
}



// WEBPACK FOOTER //
// ./src/components/ui/inputs/Input.js